<template>
  <form v-on:submit.prevent="submitForm()" v-if="this.getClient">
    <!-- 
      Adresa + minlength 5,
       Grad+ minlength , 
       Naziv firme+ minlength , 
       Email+ email required, 
       phone number required , 
       pib required minLength, 
       pdv required minlength ,
        ticketa 0
     -->
    <div class="form-row">
      <div class="form-group col-md-6">
        <label for="companyNameInput">Naziv firme</label>
        <input
          type="text"
          class="form-control"
          id="companyNameInput"
          placeholder="Naziv firme"
          :class="status($v.companyName)"
          v-model="$v.companyName.$model"
        />
        <!-- <small class="form-text errorText" v-if="!$v.companyName"
          >Naziv firme mora imati
          {{ $v.companyName.$params.minLength.min }} karaktera.</small -->
        <!-- > -->
      </div>
      <div class="form-group col-md-6">
        <label for="pibInput">PIB</label>
        <input
          type="text"
          class="form-control"
          placeholder="Maticni broj firme"
          id="pibInput"
          :class="status($v.companyRegistrationId)"
          v-model="$v.companyRegistrationId.$model"
        />
        <!-- <small
          class="form-text errorText"
          v-if="!$v.companyRegistrationId"
          >PIB mora imati minimum
          {{ $v.companyRegistrationId.$params.minLength.min }} karaktera.</small
        > -->
      </div>
    </div>
    <div class="form-row">
      <div class="form-group col-md-6">
        <label for="inputEmail">Email</label>
        <input
          type="email"
          class="form-control"
          id="inputEmail"
          placeholder="Email"
          :class="status($v.email)"
          v-model="$v.email.$model"
        />
        <!-- <small class="form-text errorText" v-if="!$v.email.email"
          >Email is in wrong format.</small
        > -->
      </div>
      <div class="form-group col-md-6">
        <label for="pdvInput">PDV</label>
        <input
          type="text"
          class="form-control"
          id="pdvInput"
          placeholder="Porez na dodatnu vrijednost"
          :class="status($v.companyRegistrationCode)"
          v-model="$v.companyRegistrationCode.$model"
        />
        <!-- <small
          class="form-text errorText"
          v-if="!$v.companyRegistrationCode.minLength"
          >PIB mora imati minimum
          {{ $v.companyRegistrationCode.$params.minLength.min }}
          karaktera.</small
        > -->
      </div>
    </div>
    <div class="form-group">
      <label for="pNumberInput">Broj telefona</label>
      <input
        type="text"
        class="form-control"
        id="pNumberInput"
        placeholder="06 "
        :class="status($v.phoneNumber)"
        v-model="$v.phoneNumber.$model"
      />
      <!-- <small class="form-text errorText" v-if="!$v.phoneNumber"
        >Broj telefona mora imati minimum
        {{ $v.phoneNumber.$params.minLength.min }} karaktera.</small
      > -->
    </div>
    <div class="form-group">
      <label for="inputAddress">Address</label>
      <input
        type="text"
        class="form-control"
        id="inputAddress"
        placeholder="Ul Avda Medjedovica"
        :class="status($v.address)"
        v-model="$v.address.$model"
      />
      <!-- <small class="form-text errorText" v-if="!$v.address.minLength"
        >Adresa mora imati minimum
        {{ $v.address.$params.minLength.min }} karaktera.</small
      > -->
    </div>
    <div class="form-row">
      <div class="form-group col-md-12">
        <label for="inputCity">City</label>
        <input
          type="text"
          class="form-control"
          id="inputCity"
          :class="status($v.city)"
          v-model="$v.city.$model"
          placeholder="Podgorica"
        />
        <!-- <small class="form-text errorText" v-if="!$v.city.minLength"
          >Grad mora imati minimum
          {{ $v.city.$params.minLength.min }} karaktera.</small
        > -->
      </div>
    </div>
    <!-- <div class="form-group">
      <div class="form-check">
        <input
          class="form-check-input"
          type="checkbox"
          id="gridCheck"
          v-model="createAccount"
          :disabled="isEmailSet"
        />
        <label class="form-check-label" for="gridCheck">
          Kreiraj nalog za klijente? (default password kvSystem123)
        </label>
      </div>
    </div> -->

    <div class="form-row" v-if="createAccount">
      <div class="form-group col-md-12">
        <label for="inputCity">Korisnicko ime</label>
        <input
          type="text"
          class="form-control"
          id="inputCity"
          v-model="userName"
          placeholder="npr. Marko Markovic"
        />
        <!-- <small class="form-text errorText" v-if="!$v.city.minLength"
          >Grad mora imati minimum
          {{ $v.city.$params.minLength.min }} karaktera.</small
        > -->
      </div>
    </div>
    <button type="submit" class="btn btn-primary">
      <!-- :disabled="submitButtonDisabled" -->
      Kreiraj novog clienta
    </button>
  </form>
</template>
<script>
import { email } from "vuelidate/lib/validators/";

export default {
  data() {
    return {
      companyName: "",
      companyRegistrationId: "",
      email: "",
      companyRegistrationCode: "",
      phoneNumber: "",
      address: "",
      city: "",
      createAccount: false,
      id: 0,
      tickets: 0,
      docId: 0,
      userName: ""
    };
  },
  created() {
    if (this.getClient) {
      this.companyName = this.getClient.companyName;
      this.companyRegistrationId = this.getClient.companyRegistrationId;
      this.email = this.getClient.email;
      this.companyRegistrationCode = this.getClient.companyRegistrationCode;
      this.phoneNumber = this.getClient.phoneNumber;
      this.address = this.getClient.address;
      this.city = this.getClient.cityCompanyHq;
      this.createAccount = this.getClient.createAccount
        ? this.getClient.createAccount
        : false;
      this.id = this.getClient.id;
      this.tickets = this.getClient.tickets;
      this.docId = this.getClient.docId;
    }
  },
  beforeDestroy() {
    this.$store.commit("setClient", {});
  },
  computed: {
    isEmailSet() {
      return this.$v.email.$dirty ? this.$v.email.$error : true;
    },
    submitButtonDisabled() {
      //Treba ispravit ovo
      if (!this.getEditMode) {
        return this.$v.email.$dirty &&
          this.$v.address.$dirty &&
          this.$v.city.$dirty &&
          this.$v.companyName.$dirty &&
          this.$v.phoneNumber.$dirty &&
          this.$v.companyRegistrationId.$dirty &&
          this.$v.companyRegistrationCode.$dirty
          ? this.$v.email.$error &&
              this.$v.address.$error &&
              this.$v.city.$error &&
              this.$v.companyName.$error &&
              this.$v.phoneNumber.$error &&
              this.$v.companyRegistrationId.$error &&
              this.$v.companyRegistrationCode.$error
          : true;
      } else {
        return false;
      }
    },
    getClient() {
      return this.$store.getters.getClient;
    },
    getEditMode() {
      return this.$store.getters.getEditMode;
    }
  },
  methods: {
    status(validation) {
      return {
        error: validation.$error,
        dirty: validation.$dirty
      };
    },
    submitForm() {
      const newClient = {
        address: this.address ? this.address : "",
        cityCompanyHq: this.city ? this.city : "",
        companyName: this.companyName,
        email: this.email ? this.email : "",
        phoneNumber: this.phoneNumber,
        companyRegistrationCode: this.companyRegistrationCode
          ? this.companyRegistrationCode
          : "",
        companyRegistrationId: this.companyRegistrationId
          ? this.companyRegistrationId
          : "",
        tickets: this.tickets ? this.tickets : 0,
        createAccount: this.createAccount,
        accountType: "customers",
        id: this.id ? this.id : 0,
        docId: this.docId ? this.docId : 0,
        userName: this.userName ? this.userName : ""
      };
      if (this.getEditMode) {
        this.$store.dispatch("commitClientEdit", newClient);
        this.$store.dispatch("editMode", false);
      } else {
        this.$store.dispatch("createClient", newClient);
      }
    }
  },
  validations: {
    companyName: {
      // minLength: minLength(3)
    },
    companyRegistrationId: {
      // required,
      // minLength: minLength(8)
    },
    email: {
      // required,
      email
    },
    companyRegistrationCode: {
      // required,
      // minLength: minLength(11)
    },
    phoneNumber: {
      // minLength: minLength(9)
    },
    address: {
      // minLength: minLength(4)
    },
    city: {
      // minLength: minLength(2)
    }
  }
};
</script>
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
input {
  border: 1px solid silver;
  border-radius: 4px;
  background: white;
  padding: 5px 10px;
}

.dirty {
  border-color: #5a5;
  background: #efe;
}

.dirty:focus {
  outline-color: #8e8;
}

.error {
  border-color: red;
  background: #fdd;
}
.errorText {
  color: red;
}
.error:focus {
  outline-color: #f99;
}
</style>
